import React, { useState, useEffect, useRef } from 'react'
import { Table } from 'rsuite'

import { Icon, IconButton, ButtonGroup, Modal, Button } from 'rsuite'
import { useSelector } from 'react-redux'

export default function ActivityCostTable({
  schema: _schema,
  onDelete,
  onEdit,
  onEditActivityBudget,
  ...props
}) {
  const { isEdit } = props
  const { Column, HeaderCell, Cell } = Table

  const { isExpanded } = useSelector((state) => state.schemaSidebar)

  const [isdelete, setIsdelete] = useState(false)
  const [deleteIndex, setDeleteIndex] = useState()

  const containerRef = useRef(null)
  // const [containerRef, setContainerRef] = useRef(null)
  const [containerWidth, setContainerWidth] = useState(0)
  const [windowWidth, setWindowWidth] = useState(0)
  const [detailWidth, setDetailWidth] = useState(300)
  const [schema, setSchema] = useState(_schema)
  const [tableData, setTableData] = useState(_schema.value)

  const handleResize = () => {
    setWindowWidth(window.innerWidth)
  }

  useEffect(() => {
    // console.log('ActivityCostTable _schema', _schema.value)
    setSchema(_schema)
    setTableData(_schema.value)
  }, [_schema])

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth)
      setTableData([])
      setTimeout(() => {
        setTableData(_schema.value)
      }, 0)
    }
  }, [containerRef, windowWidth, isExpanded])

  useEffect(() => {
    let callWidth = containerWidth - 70 - 200 - 130 - 200 - (isEdit ? 280 : 0)
    callWidth <= 300 ? 300 : callWidth
    setDetailWidth(containerWidth > 500 ? callWidth : 300)
  }, [containerWidth])

  return (
    <div ref={containerRef}>
      {/* <Table rowKey="id" height={400} autoHeight={tableData.length <= 5} wordWrap data={tableData}> */}
      <Table rowKey="id" height={400} wordWrap data={tableData}>
        <Column width={70} align="center" fixed="left">
          <HeaderCell>ลำดับที่</HeaderCell>
          <Cell>
            {(_, index) => {
              return index + 1
            }}
          </Cell>
        </Column>

        <Column minWidth={200} flexGrow={1} colSpan={2}>
          <HeaderCell>{schema?.activity.label}</HeaderCell>
          <Cell dataKey={schema?.activity.name} />
        </Column>

        <Column minWidth={100} flexGrow={1}>
          <HeaderCell>{schema?.activityDetail.label}</HeaderCell>
          <Cell dataKey={schema?.activityDetail.name} />
        </Column>

        {/* <Column width={130}>
          <HeaderCell align="right">จำนวนเงินรวม</HeaderCell>
          <Cell align="right">
            {(rowData) => {
              let totalBudget = 0
              rowData.activityBudget.forEach((item) => {
                return (totalBudget += item.sumPrice)
              })
              return budgetFormat(totalBudget)
            }}
          </Cell>
        </Column> */}

        {/* <Column width={240}>
          <HeaderCell></HeaderCell>
          <Cell align="right">
            {(rowData, index) => {
              return (
                <ButtonGroup>
                  <IconButton
                    appearance="ghost"
                    className="rs-btn-ghost-edit"
                    icon={<Icon icon="edit" className="bt-gost-icon-radius-edit" />}
                    onClick={(e) => {
                      onEditActivityBudget(rowData)
                      // onEdit(rowData)
                    }}
                  >
                    เพิ่ม/แก้ไข {schema?.buttonText ? schema?.buttonText : 'ค่าดำเนินโครงการ'}
                  </IconButton>
                </ButtonGroup>
              )
            }}
          </Cell>
        </Column> */}
        {isEdit && !schema.disabled && (
          <Column width={200} align="center" fixed="right">
            <HeaderCell></HeaderCell>

            <Cell>
              {(rowData, index) => {
                return (
                  <ButtonGroup>
                    <IconButton
                      appearance="ghost"
                      className="rs-btn-ghost-edit"
                      icon={<Icon icon="edit" className="bt-gost-icon-radius-edit" />}
                      onClick={(e) => {
                        onEdit(rowData)
                      }}
                    >
                      แก้ไข
                    </IconButton>
                    <IconButton
                      appearance="ghost"
                      className="rs-btn-ghost-cancel"
                      icon={<Icon icon="trash-o" className="bt-gost-icon-none-radius-cancel" />}
                      onClick={(e) => {
                        setIsdelete(true)
                        setDeleteIndex(index)
                      }}
                    >
                      ลบ
                    </IconButton>
                  </ButtonGroup>
                )
              }}
            </Cell>
          </Column>
        )}
      </Table>

      <Modal
        backdrop="static"
        size="xs"
        show={isdelete}
        onHide={(e) => {
          setIsdelete(false)
        }}
      >
        <Modal.Header>
          <Modal.Title>ยืนยันการลบ</Modal.Title>
        </Modal.Header>
        <Modal.Body>{'ยืนยันการลบ ' + (schema.buttonText ? schema.buttonText : '')}</Modal.Body>
        <Modal.Footer>
          <Button
            onClick={(e) => {
              onDelete(deleteIndex)
              setIsdelete(false)
            }}
            appearance="primary"
          >
            ลบ
          </Button>
          <Button
            onClick={(e) => {
              setIsdelete(false)
              setDeleteIndex('')
            }}
            appearance="subtle"
          >
            ยกเลิก
          </Button>
        </Modal.Footer>
      </Modal>
      {/* </Panel> */}
    </div>
  )
}
